import React, { useState } from "react";
import { sanitizeInput } from "../../utils/utils";
import HeaderDashboard from "../../components/layout/header/HeaderDashboard";
import "./faqs.scss";
import { faqs } from "./faqsData";
import { faqText } from "../../locales/en";

function Faqs() {
  const [selectedFaq, setSelectedFaq] = useState(faqs[0].id);

  const handleQuestionClick = (id) => {
    setSelectedFaq(selectedFaq === id ? null : id);
  };

  return (
    <div className="faq-page">
      <HeaderDashboard />

      {/* Header Section */}
      <div className="container faq-header">
        <h1>
          {faqText.FrequentlyAsked}
          <span className="highlight">{faqText.Questions}</span>
        </h1>
      </div>

      {/* FAQ Section */}
      <div className="container faq-container">
        {faqs.map((faq) => (
          <div key={faq.id} className="row faq-row">
            {/* Left Side - Question - Increased from col-md-4 to col-md-6 */}
            <div className="col-md-6">
              <div
                className={`faq-question-item ${
                  selectedFaq === faq.id ? "active" : ""
                }`}
              >
                <button
                  className={`faq-question-btn ${
                    selectedFaq === faq.id ? "active" : ""
                  }`}
                  onClick={() => handleQuestionClick(faq.id)}
                >
                  <h4 className="question-text">{faq.question}</h4>
                  <svg
                    className={`question-arrow ${
                      selectedFaq === faq.id ? "rotated" : ""
                    }`}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                  >
                    {/* Changed to point down by default */}
                    <polyline points="6,9 12,15 18,9" />
                  </svg>
                </button>
              </div>
            </div>

            {/* Right Side - Answer - Decreased from col-md-8 to col-md-6 */}
            <div className="col-md-6">
              {selectedFaq === faq.id && (
                <div className="faq-answer-container">
                  <div
                    className="faq-answer-content"
                    dangerouslySetInnerHTML={{
                      __html: sanitizeInput(faq.answer)
                    }}
                  />
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Faqs;
